import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import { QueryParamProvider } from 'use-query-params';
import App from '../App';
import client from '../apollo';

import { ToastContainer, Slide } from 'react-toastify';

const Root = () => {
	return(
		<ApolloProvider client={client}>
			<Router>
				<QueryParamProvider ReactRouterRoute={Route}>	
					<App />
				</QueryParamProvider>
			</Router>
			<ToastContainer position="top-right" transition={Slide} hideProgressBar newestOnTop closeOnClick />
		</ApolloProvider>
	);
}

export default Root;
